import { Geodesic } from "geographiclib-geodesic";
import { VehicleGeolocated } from "./index";

export const getDistanceInKm = (
  [lat1, lon1]: [number, number],
  [lat2, lon2]: [number, number],
) => {
  const geod = Geodesic.WGS84;
  const result = geod.Inverse(lat1, lon1, lat2, lon2);
  return (result.s12 ?? 0) / 1000; // result.s12 is in meters, we convert to km
};

export const fakeVehicleGeolocatedForDemo: VehicleGeolocated[] = [
  {
    uuid: "e66252a8-a353-4096-a592-88b0dc3998bc",
    registrationNumber: "GE-123-OL",
    model: "CLIO",
    reference: "Geoloc 1",
    lastLatitude: 48.866667,
    lastLongitude: 2.333333,
    distance: 0,
    driverName: "John Doe",
    driverPhone: "07XXX45678",
    dataPoints: [],
  },
  {
    uuid: "e66252a8-a353-4096-a592-88b0dc399800",
    registrationNumber: "OC-444-AL",
    model: "DS",
    reference: "Geoloc 2",
    lastLatitude: 48.8566,
    lastLongitude: 2.3522,
    distance: 0,
    driverName: "John Smith",
    driverPhone: "07XXX34455",
    dataPoints: [
      {
        lat: 48.8566,
        lon: 2.3522,
        date: "2025-01-01T10:00:00Z",
      },
      {
        lat: 48.8571,
        lon: 2.353,
        date: "2025-01-01T10:02:00Z",
      },
      {
        lat: 48.8577,
        lon: 2.3541,
        date: "2025-01-01T10:04:00Z",
      },
      {
        lat: 48.8582,
        lon: 2.3555,
        date: "2025-01-01T10:06:00Z",
      },
      {
        lat: 48.8587,
        lon: 2.3568,
        date: "2025-01-01T10:08:00Z",
      },
      {
        lat: 48.8591,
        lon: 2.3579,
        date: "2025-01-01T10:10:00Z",
      },
      {
        lat: 48.8596,
        lon: 2.3591,
        date: "2025-01-01T10:12:00Z",
      },
      {
        lat: 48.8601,
        lon: 2.3604,
        date: "2025-01-01T10:14:00Z",
      },
      {
        lat: 48.8606,
        lon: 2.3616,
        date: "2025-01-01T10:16:00Z",
      },
      {
        lat: 48.8611,
        lon: 2.3629,
        date: "2025-01-01T10:18:00Z",
      },
    ],
  },
  {
    uuid: "e66252a8-a353-4096-a592-88b0dc3998b01",
    registrationNumber: "IS-987-AT",
    model: "DACIA",
    reference: "Geoloc 3",
    lastLatitude: 48.85837,
    lastLongitude: 2.294481,
    distance: 0,
    driverName: "Jeanne Doe",
    driverPhone: "07XXX35678",
    dataPoints: [
      {
        lat: 48.85837,
        lon: 2.294481,
        date: "2025-01-01T10:00:00Z",
      },
      {
        lat: 48.858,
        lon: 2.2909,
        date: "2025-01-01T10:03:00Z",
      },
      {
        lat: 48.85755,
        lon: 2.2872,
        date: "2025-01-01T10:06:00Z",
      },
      {
        lat: 48.8571,
        lon: 2.2835,
        date: "2025-01-01T10:09:00Z",
      },
      {
        lat: 48.85675,
        lon: 2.2802,
        date: "2025-01-01T10:12:00Z",
      },
      {
        lat: 48.8564,
        lon: 2.2769,
        date: "2025-01-01T10:15:00Z",
      },
      {
        lat: 48.8559,
        lon: 2.2731,
        date: "2025-01-01T10:18:00Z",
      },
      {
        lat: 48.8554,
        lon: 2.2697,
        date: "2025-01-01T10:21:00Z",
      },
      {
        lat: 48.8549,
        lon: 2.2662,
        date: "2025-01-01T10:24:00Z",
      },
      {
        lat: 48.8545,
        lon: 2.2628,
        date: "2025-01-01T10:27:00Z",
      },
      {
        lat: 48.8549,
        lon: 2.263,
        date: "2025-01-01T10:30:00Z",
      },
      {
        lat: 48.8549,
        lon: 2.269,
        date: "2025-01-01T10:33:00Z",
      },
      {
        lat: 48.8549,
        lon: 2.2704,
        date: "2025-01-01T10:45:00Z",
      },
    ],
  },
  {
    uuid: "e66252a8-a353-4096-a592-88b0dc399802",
    registrationNumber: "TI-123-ON",
    model: "X3",
    reference: "Geoloc 4",
    lastLatitude: 48.75,
    lastLongitude: 2.4,
    distance: 0,
    driverName: "Grace Johns",
    driverPhone: "07XXX45566",
    dataPoints: [],
  },
  {
    uuid: "e66252a8-a353-4096-a592-88b0dc399803",
    registrationNumber: "AA-123-ZZ",
    model: "CLIO",
    reference: "Geoloc 5",
    lastLatitude: 45.75,
    lastLongitude: 4.85,
    distance: 0,
    driverName: "Jean Legrand",
    driverPhone: "07XXX70707",
    dataPoints: [],
  },
];
